/**
 * File: ant-video-parent.js
 * Created Date: Mon Mar 11 2019
 * Author: Coffee
 * Description: 
 * 
 * Copyright (c) 2019 HuluGames
 */

import log from './log';
import Postmate from 'postmate';

class AntVideoParent {
    constructor (child) {
        this._child = child;
        this._listener = null;

        this._child.get('width')
            .then(width => {
                log.info(`recv child width = ${width}`);
                this._child.frame.style.width = `${width}px`;
                this._child.frame.scrolling = "no";
                // this._child.frame.allowFullscreen = "allowfullscreen";
            });

        this._child.get('height')
            .then(height => {
                log.info(`recv child height = ${height}`);
                this._child.frame.style.height = `${height}px`;
            });

        this._child.get('model')
            .then(model => {
                // 检查model的list
                log.info('methodList is ', model);

                this._addEventHandler('xAPI', this._onXAPIEvent.bind(this));
                this._addEventHandler('ant-event', this._onAntEvent.bind(this));
                this._addEventHandler('video-play', this._onVideoPlayEvent.bind(this));
                this._addEventHandler('video-pause', this._onVideoPauseEvent.bind(this));
                
                // 绑定一下callAPI
                for (let i = 0; i < model.length; ++i) {
                    if (model[i].callAble && model[i].type === 'function') {
                        this[model[i].key] = (data) => this._child.call(model[i].key, data);
                    }
                }
            });
    }

    _addEventHandler (type, handler) {
        this._child.on(type, event => {
            handler(event);
        });
    }

    _onXAPIEvent (event) {
        if (this._listener) {
            this._listener('xAPI', event);
        }
    }

    _onAntEvent (event) {
        if (this._listener) {
            this._listener('ant-event', event);
        }
    }
    _onVideoPlayEvent (event) {
        if (this._listener) {
            this._listener('video-play', event);
        }
    }
    _onVideoPauseEvent (event) {
        if (this._listener) {
            this._listener('video-pause', event);
        }
    }

    setEventListener (listener) {
        this._listener = listener;
    }

    // /**
    //  * @description 控制播放视频
    //  *
    //  * @memberof AntVideoParent
    //  */
    // play () {
    //     this._child.call('play');
    // }

    // pause () {
    //     this._child.call('pause');
    // }

    // resume () {
    //     this._child.call('resume');
    // }

    // toggleFullScreen () {
    //     this._child.call('toggleFullScreen');
    // }
}


const AntVideoLauncher = function (container, url, cssList) {
    return new Postmate.Promise((resolve, reject) => {
        const handshake = new Postmate({
            container: container,
            url: url,
            classListArray: cssList || ['ant-video-frame']
        });
    
        handshake.then(child => {
            log.info('create hand shake success!');
            child.frame.scrolling="no";
            child.frame.allowtransparency="yes";
            resolve(new AntVideoParent(child));
        })
        .catch(err => {
            log.error('can not create handshake. err = ', err);
            reject(err);
        });
    });
};

export default AntVideoLauncher;
